import { API_URL } from "./config";
import React, {
  useState
} from "react";
import {
  useNavigate
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function Register() {

  const navigate =
    useNavigate();

  const [form, setForm] =
    useState({
      name: "",
      email: "",
      mobile_number: "",
      aadhaar_number: "",
      password: "",
      confirm: "",
      profile:
        "Standard",
    });

  const [error,
    setError
  ] = useState("");

  const [loading,
    setLoading
  ] = useState(false);

  const [otp,
    setOtp
  ] = useState("");

  const [
    emailVerified,
    setEmailVerified
  ] = useState(false);

  const [
    otpSent,
    setOtpSent
  ] = useState(false);

  const [
    otpLoading,
    setOtpLoading
  ] = useState(false);

  // ==========================
  // HANDLE INPUT
  // ==========================
  const handleChange = (
    e
  ) => {

    setForm({
      ...form,
      [
        e.target.name
      ]:
        e.target.value,
    });
  };

  // ==========================
  // SEND EMAIL OTP
  // ==========================
  const handleSendOtp =
    async () => {

      setError("");

      if (
        !form.email
      ) {
        return setError(
          "Enter email first."
        );
      }

      try {

        setOtpLoading(
          true
        );

        const res =
          await fetch(
            `${API_URL}/api/send-email-otp`,
            {
              method:
                "POST",

              headers:
              {
                "Content-Type":
                  "application/json",
              },

              body:
                JSON.stringify(
                  {
                    email:
                      form.email,
                  }
                ),
            }
          );

        const data =
          await res.json();

        if (
          res.ok
        ) {

          alert(
            "✅ OTP sent to email"
          );

          setOtpSent(
            true
          );

        } else {

          setError(
            data.error ||
            "Failed to send OTP"
          );
        }

      } catch (
        err
      ) {

        console.error(
          err
        );

        setError(
          "Network error"
        );

      } finally {

        setOtpLoading(
          false
        );
      }
    };

  // ==========================
  // VERIFY EMAIL OTP
  // ==========================
  const handleVerifyOtp =
    async () => {

      setError("");

      if (
        !otp
      ) {
        return setError(
          "Enter OTP"
        );
      }

      try {

        const res =
          await fetch(
            `${API_URL}/api/verify-email-otp`,
            {
              method:
                "POST",

              headers:
              {
                "Content-Type":
                  "application/json",
              },

              body:
                JSON.stringify(
                  {
                    email:
                      form.email,
                    otp,
                  }
                ),
            }
          );

        const data =
          await res.json();

        if (
          res.ok
        ) {

          alert(
            "✅ Email verified"
          );

          setEmailVerified(
            true
          );

        } else {

          setError(
            data.error ||
            "OTP verification failed"
          );
        }

      } catch (
        err
      ) {

        console.error(
          err
        );

        setError(
          "Network error"
        );
      }
    };

  // ==========================
  // REGISTER
  // ==========================
  const handleSubmit =
    async (e) => {

      e.preventDefault();

      setError("");

      if (
        !form.name ||
        !form.email ||
        !form.mobile_number ||
        !form.password ||
        !form.confirm
      ) {
        return setError(
          "Please fill all fields."
        );
      }

      if (
        !emailVerified
      ) {
        return setError(
          "Verify email first."
        );
      }

      if (
        form.password
        !==
        form.confirm
      ) {
        return setError(
          "Passwords do not match."
        );
      }

      try {

        setLoading(
          true
        );

        const res =
          await fetch(
            `${API_URL}/api/register`,
            {
              method:
                "POST",

              headers:
              {
                "Content-Type":
                  "application/json",
              },

              body:
                JSON.stringify(
                  {
                    name:
                      form.name,
                    email:
                      form.email,
                    mobile_number:
                      form.mobile_number,
                    aadhaar_number:
                      form.aadhaar_number,
                    password:
                      form.password,
                    profile:
                      form.profile,
                  }
                ),
            }
          );

        const data =
          await res.json();

        if (
          res.ok
        ) {

          alert(
            "✅ Registered successfully!"
          );

          navigate(
            "/login"
          );

        } else {

          setError(
            data.error ||
            "Registration failed."
          );
        }

      } catch (
        err
      ) {

        console.error(
          err
        );

        setError(
          "❌ Network error. Try again."
        );

      } finally {

        setLoading(
          false
        );
      }
    };

  return (
    <div className="container d-flex justify-content-center align-items-start align-items-md-center min-vh-100 bg-light py-4">

      <form
        onSubmit={
          handleSubmit
        }
        className="bg-white p-4 rounded shadow w-100"
        style={{
          maxWidth:
            "450px",
        }}
      >

        <h2 className="text-center mb-4">
          Register for{" "}
          <strong>
            I-PQSign
          </strong>
        </h2>

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {/* NAME */}
        <div className="mb-3">
          <label className="form-label">
            Full Name
          </label>

          <input
            name="name"
            type="text"
            className="form-control"
            placeholder="Enter your name"
            value={
              form.name
            }
            onChange={
              handleChange
            }
          />
        </div>

        {/* EMAIL */}
        <div className="mb-3">

          <label className="form-label">
            Email Address
          </label>

          <div className="d-flex gap-2">

            <input
              name="email"
              type="email"
              className="form-control"
              placeholder="Enter email"
              value={
                form.email
              }
              onChange={
                handleChange
              }
              disabled={
                emailVerified
              }
            />

            {!emailVerified && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  handleSendOtp
                }
                disabled={
                  otpLoading
                }
              >
                {otpLoading
                  ? "Sending..."
                  : "Verify"}
              </button>
            )}
          </div>
        </div>

        {/* OTP */}
        {otpSent &&
          !emailVerified && (

          <div className="mb-3">

            <label className="form-label">
              Enter OTP
            </label>

            <div className="d-flex gap-2">

              <input
                type="text"
                className="form-control"
                placeholder="Enter OTP"
                value={
                  otp
                }
                onChange={(
                  e
                ) =>
                  setOtp(
                    e.target
                      .value
                  )
                }
              />

              <button
                type="button"
                className="btn btn-success"
                onClick={
                  handleVerifyOtp
                }
              >
                Submit
              </button>
            </div>
          </div>
        )}

        {/* VERIFIED */}
        {emailVerified && (
          <div className="alert alert-success">
            ✅ Email
            verified
          </div>
        )}

        {/* SHOW AFTER EMAIL VERIFIED */}
        {emailVerified && (
          <>

            <div className="mb-3">
              <label className="form-label">
                Mobile Number
              </label>

              <input
                name="mobile_number"
                type="text"
                className="form-control"
                placeholder="Enter mobile number"
                value={
                  form.mobile_number
                }
                onChange={
                  handleChange
                }
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                Aadhaar Number
                (Optional)
              </label>

              <input
                name="aadhaar_number"
                type="text"
                className="form-control"
                placeholder="Enter Aadhaar number"
                value={
                  form.aadhaar_number
                }
                onChange={
                  handleChange
                }
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                Profile
              </label>

              <select
                name="profile"
                className="form-select"
                value={
                  form.profile
                }
                onChange={
                  handleChange
                }
              >
                <option value="Standard">
                  Standard
                </option>

                <option value="Premium">
                  Premium
                </option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">
                Password
              </label>

              <input
                name="password"
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={
                  form.password
                }
                onChange={
                  handleChange
                }
              />
            </div>

            <div className="mb-4">
              <label className="form-label">
                Confirm Password
              </label>

              <input
                name="confirm"
                type="password"
                className="form-control"
                placeholder="Confirm password"
                value={
                  form.confirm
                }
                onChange={
                  handleChange
                }
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={
                loading
              }
            >
              {loading
                ? "Registering..."
                : "Register"}
            </button>
          </>
        )}

        <p className="text-center mt-3">
          Already have an account?{" "}

          <span
            onClick={() =>
              navigate(
                "/login"
              )
            }
            className="text-primary text-decoration-underline"
            style={{
              cursor:
                "pointer",
            }}
          >
            Login here
          </span>
        </p>
      </form>
    </div>
  );
}

export default Register;